import { render } from "./AdminActionLog.vue?vue&type=template&id=17a88b0a&scoped=true"
import script from "./AdminActionLog.vue?vue&type=script&lang=js"
export * from "./AdminActionLog.vue?vue&type=script&lang=js"

import "./AdminActionLog.vue?vue&type=style&index=0&id=17a88b0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a88b0a"]])

export default __exports__